import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { AppState, initialAppState } from '../app-state.initial-state';

export const logoutReducer: CaseReducer<AppState, PayloadAction<boolean | undefined>> = (state, { payload }) => {
  return  {
    ...initialAppState,
    isLoggingOutFromRemoteTab: payload || false,
  };
};
